// DS1.7.1
import React from 'react';
import c from 'classnames';
import s from './NotificationCounter.scss';
const NotificationCounter = ({ children, color = 'red', className })=>/*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], s[`color-${color}`], className)
    }, children);
NotificationCounter.displayName = 'NotificationCounter';
export default NotificationCounter;

//# sourceMappingURL=NotificationCounter.js.map